import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Safety improvement: Validate DOM element exists before rendering to prevent null reference errors
const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found. Cannot render application.')
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)